import { render } from "./PaperRecord.vue?vue&type=template&id=8c153672"
import script from "./PaperRecord.vue?vue&type=script&lang=js"
export * from "./PaperRecord.vue?vue&type=script&lang=js"

import "./PaperRecord.vue?vue&type=style&index=0&id=8c153672&lang=less"

import exportComponent from "/codebuild/output/src3396806294/src/NewSmartDash/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__